import { getToken } from '@/utils/adminAuth'
import { request } from './http'
import { resolveUploadUrl } from './categories'

function resolveApiBase() {
  const fromEnv = process.env.VUE_APP_API_BASE
  if (fromEnv != null && String(fromEnv).trim() !== '') {
    return String(fromEnv).replace(/\/$/, '')
  }
  return ''
}

export { resolveUploadUrl }

export function fetchPublicProducts({ category = '', limit } = {}) {
  const params = new URLSearchParams()
  if (category) params.set('category', category)
  if (limit != null && limit !== '') params.set('limit', String(limit))
  const q = params.toString() ? `?${params.toString()}` : ''
  return request(`/api/products${q}`)
}

export function fetchRecentProducts(limit = 6) {
  return fetchPublicProducts({ limit })
}

export function fetchPublicProduct(id) {
  return request(`/api/products/${id}`)
}

export function mapStorefrontProduct(row) {
  const detailUrls = []
  for (const url of row.detail_image_urls || []) {
    detailUrls.push(resolveUploadUrl(url))
  }
  for (const path of row.detail_images || []) {
    const resolved = resolveUploadUrl(path.startsWith('/') ? path : `/uploads/${path}`)
    if (!detailUrls.includes(resolved)) detailUrls.push(resolved)
  }
  const mainImageUrl = resolveUploadUrl(row.main_image_url || row.main_image_path || '')

  return {
    id: row.id,
    nameEn: row.name_en,
    nameZh: row.name_zh || '',
    categoryId: row.category_id,
    categorySlug: row.category_slug,
    categoryNameEn: row.category_name_en,
    categoryNameZh: row.category_name_zh || '',
    mainImageUrl,
    detailImageUrls: detailUrls,
    galleryImages: buildGalleryImages(mainImageUrl, detailUrls),
    description: row.description || ''
  }
}

export function buildGalleryImages(mainImageUrl, detailImageUrls = []) {
  const images = []
  if (mainImageUrl) images.push(mainImageUrl)
  for (const url of detailImageUrls) {
    if (url && url !== mainImageUrl && !images.includes(url)) {
      images.push(url)
    }
  }
  return images
}

export function fetchProducts({ keyword = '', categoryId = '' } = {}) {
  const params = new URLSearchParams()
  if (keyword) params.set('keyword', keyword)
  if (categoryId) params.set('category_id', String(categoryId))
  const q = params.toString() ? `?${params.toString()}` : ''
  return request(`/api/admin/products${q}`)
}

export function createProduct(data) {
  return request('/api/admin/products', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

export function updateProduct(id, data) {
  return request(`/api/admin/products/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

export function deleteProduct(id) {
  return request(`/api/admin/products/${id}`, {
    method: 'DELETE'
  })
}

export async function uploadProductImage(file) {
  const formData = new FormData()
  formData.append('file', file)

  const headers = {}
  const token = getToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const res = await fetch(`${resolveApiBase()}/api/admin/products/upload`, {
    method: 'POST',
    headers,
    body: formData
  })

  let body = null
  const text = await res.text()
  if (text) {
    try {
      body = JSON.parse(text)
    } catch {
      body = { code: res.status, message: text }
    }
  }

  if (!res.ok) {
    const err = new Error(body?.message || res.statusText || '上传失败')
    err.code = body?.code ?? res.status
    throw err
  }

  return body
}
